/* ============================================================
   GOBLIN GEAR — CART DRAWER v2 (gg-cart.js)
   Single source of truth for the AJAX cart drawer:
   items + qty steppers, gamified free-shipping bar, Bundle &
   Save (2+ items = 5% / 4+ items = 10%), "Add to your bundle" Wave 1 tiles,
   and in-cart discount codes via /cart/update.js.
   Ported from the live theme. storefront.js skips its own cart
   code when window.GG_CART_V2 is set.
   Masked. But known.
   ============================================================ */
(function () {
  'use strict';
  window.GG_CART_V2 = true;

  var THRESH = window.GG_SHIP_THRESHOLD || 12500; // cents
  var CFG = { tiers: [{ n: 2, pct: 5 }, { n: 4, pct: 10 }], wave1: [] };
  var cfgEl = document.getElementById('ggCartConfig');
  try { if (cfgEl) { var parsed = JSON.parse(cfgEl.textContent); if (parsed && parsed.tiers) CFG = parsed; } } catch (e) {}
  var TIERS = (CFG.tiers || []).filter(function (t) { return t && t.pct > 0; }).sort(function (a, b) { return a.n - b.n; });

  var overlay = document.getElementById('overlay');
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  var els = {};
  ['cartBody', 'cartCount', 'cartSubtotal', 'cartOriginal', 'ggOrigRow', 'ggSaveRow', 'ggSaveVal', 'ggTotalLabel', 'ggShip', 'ggShipMsg', 'ggShipFill', 'ggShipGoal', 'ggLadder', 'ggTiers', 'ggLadderNote', 'ggAddons', 'ggAddonsTitle', 'ggAddonsRail', 'ggDiscForm', 'ggDiscInput', 'ggDiscApply', 'ggDiscChips', 'ggDiscMsg']
    .forEach(function (id) { els[id] = document.getElementById(id); });

  function fmt(c) { return '$' + ((c || 0) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  var lastCart = null;

  /* ---------------- open / close ---------------- */
  function openCart() { drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); }
  function closeCart() { drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); }
  window.ggOpenCart = function () { refresh(true); };
  window.GGCart = { refresh: function () { return refresh(true); }, open: openCart, close: closeCart };
  document.addEventListener('gg:cart:refresh', function () { refresh(true); });

  var cartBtn = document.getElementById('cartBtn'), cartClose = document.getElementById('cartClose');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  /* ---------------- cart I/O ---------------- */
  function refresh(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); if (open) openCart(); return c; })
      .catch(function () { if (open) openCart(); });
  }
  function addToCart(id, qty, selling_plan) {
    var b = { items: [{ id: id, quantity: qty || 1 }] };
    if (selling_plan) b.items[0].selling_plan = selling_plan;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(b) })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(true); });
  }
  function changeQty(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(render);
  }
  window.ggAddVariant = addToCart;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-variant-id]'); if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id'); if (!id) return;
    btn.classList.add('busy');
    addToCart(id, parseInt(btn.getAttribute('data-qty')) || 1, btn.getAttribute('data-selling-plan') || null)
      .then(function () { btn.classList.remove('busy'); });
  });

  /* ---------------- render ---------------- */
  function render(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    if (els.cartCount) els.cartCount.textContent = cart.item_count;

    if (els.cartBody) {
      els.cartBody.innerHTML = cart.items.length ? cart.items.map(function (i) {
        var meta = (i.variant_title && i.variant_title !== 'Default Title') ? esc(i.variant_title) : '';
        var lineWas = i.original_line_price > i.final_line_price ? '<s class="ci-was">' + fmt(i.original_line_price) + '</s> ' : '';
        return '<div class="cart-item" data-key="' + i.key + '">' +
          '<div class="ci-img">' + (i.image ? '<img src="' + i.image + '" alt="">' : '') + '</div>' +
          '<div><h4>' + esc(i.product_title) + '</h4>' +
          '<div class="ci-meta">' + (meta ? meta + ' · ' : '') +
          '<span class="ci-step"><button type="button" class="ci-qty" data-key="' + i.key + '" data-q="' + (i.quantity - 1) + '" aria-label="Remove one">&minus;</button><b>' + i.quantity + '</b><button type="button" class="ci-qty" data-key="' + i.key + '" data-q="' + (i.quantity + 1) + '" aria-label="Add one">+</button></span>' +
          ' · <button class="ci-remove" data-key="' + i.key + '">Remove</button></div></div>' +
          '<div class="ci-price">' + lineWas + fmt(i.final_line_price) + '</div></div>';
      }).join('') : '<p class="cart-empty">Your cart is empty. Go arm yourself.</p>';
      els.cartBody.querySelectorAll('.ci-remove').forEach(function (b) { b.addEventListener('click', function () { changeQty(b.dataset.key, 0); }); });
      els.cartBody.querySelectorAll('.ci-qty').forEach(function (b) { b.addEventListener('click', function () { changeQty(b.dataset.key, Math.max(0, parseInt(b.dataset.q) || 0)); }); });
    }

    renderShip(cart);
    renderLadder(cart);
    renderTotals(cart);
    renderCodes(cart);
    loadAddons(cart);
  }

  /* ---------------- free-shipping (gamified) ---------------- */
  var shipDone = null;
  function renderShip(cart) {
    if (!els.ggShip || THRESH <= 0) return;
    if (!cart.items.length) { els.ggShip.hidden = true; shipDone = null; return; }
    els.ggShip.hidden = false;
    var total = cart.total_price;
    var pct = Math.min(total / THRESH, 1) * 100;
    if (els.ggShipFill) els.ggShipFill.style.width = pct + '%';
    var done = total >= THRESH;
    els.ggShip.classList.toggle('done', done);
    if (els.ggShipMsg) {
      if (done) {
        els.ggShipMsg.innerHTML = '🎉 <b>FREE U.S. SHIPPING UNLOCKED</b>';
        if (shipDone === false && els.ggShipGoal) { els.ggShipGoal.classList.remove('pop'); void els.ggShipGoal.offsetWidth; els.ggShipGoal.classList.add('pop'); }
      } else {
        els.ggShipMsg.innerHTML = 'You’re <b>' + fmt(THRESH - total) + '</b> away from free shipping';
      }
    }
    shipDone = done;
  }

  /* ---------------- bundle ladder ---------------- */
  function renderLadder(cart) {
    if (!els.ggLadder || !TIERS.length) return;
    els.ggLadder.hidden = false;
    var n = cart.item_count;
    var max = TIERS[TIERS.length - 1], cur = null;
    TIERS.forEach(function (t) { if (n >= t.n) cur = t; });
    if (els.ggTiers) els.ggTiers.innerHTML = TIERS.map(function (t) {
      return '<span class="gg-tier' + (cur === t ? ' hit' : '') + '">' + t.n + '+ items = ' + t.pct + '% off</span>';
    }).join('');
    var note;
    if (n >= max.n) note = max.pct + '% off unlocked on your whole bundle.';
    else {
      var next = null;
      for (var i = 0; i < TIERS.length; i++) { if (n < TIERS[i].n) { next = TIERS[i]; break; } }
      var d = next.n - n;
      note = n < TIERS[0].n ? 'Add ' + d + ' or more items to unlock ' + next.pct + '% off your whole bundle.' : 'Add ' + d + ' more item' + (d === 1 ? '' : 's') + ' to unlock ' + next.pct + '% off your whole bundle.';
    }
    if (els.ggLadderNote) els.ggLadderNote.textContent = note;
  }

  /* ---------------- totals ---------------- */
  function renderTotals(cart) {
    var saved = cart.total_discount || 0;
    if (els.cartSubtotal) els.cartSubtotal.textContent = fmt(cart.total_price);
    if (els.ggOrigRow) els.ggOrigRow.hidden = saved <= 0;
    if (els.cartOriginal) els.cartOriginal.textContent = fmt(cart.original_total_price);
    if (els.ggSaveRow) els.ggSaveRow.hidden = saved <= 0;
    if (els.ggSaveVal) els.ggSaveVal.textContent = '−' + fmt(saved);
    if (els.ggTotalLabel) els.ggTotalLabel.textContent = saved > 0 ? 'Total' : 'Subtotal';
  }

  /* ---------------- discount codes ---------------- */
  function codes() { return ((lastCart && lastCart.discount_codes) || []).filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; }); }
  function setDiscMsg(txt, ok) { if (!els.ggDiscMsg) return; els.ggDiscMsg.textContent = txt || ''; els.ggDiscMsg.className = 'gg-disc-msg' + (txt ? (ok ? ' ok' : ' err') : ''); }
  function applyCodes(list, tried) {
    if (els.ggDiscApply) { els.ggDiscApply.disabled = true; els.ggDiscApply.textContent = '...'; }
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (els.ggDiscApply) { els.ggDiscApply.disabled = false; els.ggDiscApply.textContent = 'Apply'; }
        if (cart && cart.items) {
          if (tried) {
            var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === tried.toUpperCase(); })[0];
            if (hit && hit.applicable !== false) {
              setDiscMsg('“' + tried.toUpperCase() + '” applied 🟢', true);
              if (els.ggDiscInput) els.ggDiscInput.value = '';
            } else {
              setDiscMsg('“' + tried.toUpperCase() + '” isn’t valid for this cart.', false);
            }
          }
          render(cart);
        } else {
          setDiscMsg((cart && (cart.message || cart.description)) || 'Couldn’t update discount. Try again.', false);
        }
        return cart;
      })
      .catch(function () {
        if (els.ggDiscApply) { els.ggDiscApply.disabled = false; els.ggDiscApply.textContent = 'Apply'; }
        setDiscMsg('Couldn’t update discount. Try again.', false);
      });
  }
  if (els.ggDiscForm) {
    els.ggDiscForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = ((els.ggDiscInput && els.ggDiscInput.value) || '').trim();
      if (!code) return;
      var cur = codes();
      if (cur.map(function (c) { return c.toUpperCase(); }).indexOf(code.toUpperCase()) > -1) { setDiscMsg('“' + code.toUpperCase() + '” is already applied.', true); return; }
      applyCodes(cur.concat([code]), code);
    });
  }
  function renderCodes(cart) {
    if (!els.ggDiscChips) return;
    var list = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false; });
    els.ggDiscChips.innerHTML = list.map(function (d) {
      return '<span class="gg-chip"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg>' + esc(d.code.toUpperCase()) + '<button type="button" class="gg-chip-x" data-code="' + esc(d.code) + '" aria-label="Remove code">&times;</button></span>';
    }).join('');
    els.ggDiscChips.querySelectorAll('.gg-chip-x').forEach(function (b) {
      b.addEventListener('click', function () {
        var keep = codes().filter(function (c) { return c.toUpperCase() !== b.dataset.code.toUpperCase(); });
        applyCodes(keep, null).then(function () { setDiscMsg('Code removed.', true); });
      });
    });
  }

  /* ---------------- add to your bundle (Wave 1 tiles) ---------------- */
  function loadAddons(cart) {
    if (!els.ggAddons || !els.ggAddonsRail) return;
    var inCart = {}, last = cart.items.length ? cart.items[cart.items.length - 1] : null, lastSlot = 'elbow';
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    (CFG.wave1 || []).forEach(function (p) { if (last && p.pid === last.product_id) lastSlot = p.slot; });
    var other = lastSlot === 'wrist' ? 'elbow' : 'wrist';
    var list = (CFG.wave1 || []).filter(function (p) { return p && p.id && !inCart[p.pid]; });
    list.sort(function (x, y) { return (x.slot === other ? 0 : 1) - (y.slot === other ? 0 : 1); });
    if (!list.length) { els.ggAddons.hidden = true; return; }
    els.ggAddons.hidden = false;
    els.ggAddonsRail.innerHTML = list.map(function (p) {
      var ok = p.available !== false;
      return '<div class="gg-addon' + (ok ? '' : ' is-out') + '">' +
        '<a class="ga-img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="ga-name">' + esc(p.title) + '</div>' +
        '<div class="ga-prices"><b>' + fmt(p.price) + '</b></div>' +
        '<button type="button" class="ga-add"' + (ok ? ' data-variant-id="' + p.id + '"' : ' disabled') + '>' + (ok ? '+ Add' : 'Sold out') + '</button></div>';
    }).join('');
  }

  refresh(false);
})();
